export default __webpack_public_path__ + "static/media/washingMashinGreen.4156ed5a.svg";